// extracted by mini-css-extract-plugin
export default {"container":"ApproveVoterForm_container__qof6X","title":"ApproveVoterForm_title__+bHKN","section":"ApproveVoterForm_section__O0T9x"};